import React, {useEffect, useState} from 'react'
import {Col, Row} from 'antd'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
//Components
import {TableDetail, RowTableDetail} from "../../Common/View/TableViewDetail";
// Constant
import typo from '../../../constants/dictionaries'
import Api from "../../../api";
import Message from "../../Messages";
import helper from '../../../helper/helper'

const Organization = ({data, user}) => {
  const [organization, setOrganization] = useState({});

  const {idDonViXinCapPhep} = data || {};

  useEffect(() => {
    idDonViXinCapPhep && new Api().get_DonViXinCapPhepById({token: user.access_token, id: idDonViXinCapPhep})
      .then(res => {
        setOrganization(res);
      })
      .catch(err => {
        // Message.error(err.message)
      })
  }, [data]);

  const {donViXinCapPhep} = organization;

  const {
    diaChi,
    ten,
  } = donViXinCapPhep || {};

  return (
    <Row>
      <TableDetail>
        <RowTableDetail title={typo.cscore_license_organization}>{ten}</RowTableDetail>
        {/*<RowTableDetail title="Ngày cấp">{helper.formatDate(ngayTao)}</RowTableDetail>*/}
        {/*<RowTableDetail title="Số điện thoại">{soDienThoai}</RowTableDetail>*/}
        {/*<RowTableDetail title="Email">{email}</RowTableDetail>*/}
        {/*<RowTableDetail title="Người đại diện">{nguoiTao}</RowTableDetail>*/}
        {/*<RowTableDetail title="Số ĐKKĐ/QĐTL">{dkkD_So}</RowTableDetail>*/}
        {/*<RowTableDetail title="Nơi cấp">{cndT_NoiCap}</RowTableDetail>*/}
        {/*<RowTableDetail title="Fax">{fax}</RowTableDetail>*/}
        <RowTableDetail title="Địa chỉ">{diaChi}</RowTableDetail>
        {/*<RowTableDetail title="Địa chỉ chủ sở hữu">{ndD_DiaChi}</RowTableDetail>*/}
      </TableDetail>
    </Row>
  )
};

Organization.propTypes = {
  data: PropTypes.any.isRequired
};

const mapStateToProps = (state) => ({
  user: state.oidc.user
});

export default connect(mapStateToProps)(Organization)